<template>
  <svg
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#4f2b1b">
      <path d="m11.33 10.51c.44-.75 1.3-.21 1.85.87s1.34 3.65.19 4.44-1.73-.9-2.14-2a3.52 3.52 0 0 1 .1-3.31z" />
      <path d="m17.71 5.54c.59-.65 1.32.06 1.64 1.22s.59 3.85-.7 4.39-1.52-1.23-1.65-2.41a3.58 3.58 0 0 1 .71-3.2z" />
      <path
        d="m14.34 8.07c.52-.71 1.32-.07 1.75 1.06s.95 3.77-.28 4.43-1.63-1.07-1.92-2.24a3.55 3.55 0 0 1 .45-3.25z"
      />
      <path d="m24.51 6.14c.87.07.75 1.08 0 2s-2.7 2.86-3.91 2.12.06-1.95.9-2.8a3.53 3.53 0 0 1 3.01-1.32z" />
      <path d="m24.89 13.22c.73-.47.15-1.31-.95-1.81s-3.69-1.21-4.43 0 1 1.69 2.1 2.06a3.54 3.54 0 0 0 3.28-.25z" />
      <path d="m22.23 15.82c.73-.47.15-1.3-.95-1.81s-3.69-1.2-4.43 0 1 1.7 2.1 2.07a3.57 3.57 0 0 0 3.28-.26z" />
      <path d="m19.78 18.52c.74-.46.16-1.3-.94-1.81s-3.7-1.2-4.44 0 1 1.7 2.1 2.07a3.54 3.54 0 0 0 3.28-.26z" />
      <path d="m8.66 13.86c.44-.76 1.3-.21 1.84.87s1.35 3.65.2 4.43-1.73-.89-2.15-2a3.53 3.53 0 0 1 .11-3.3z" />
      <path d="m17.2 20.81c.74-.46.16-1.3-.94-1.81s-3.69-1.2-4.43 0 1 1.7 2.1 2.07a3.56 3.56 0 0 0 3.27-.26z" />
      <path
        d="m15 0a15 15 0 1 0 15 15 15 15 0 0 0 -15-15zm10.2 23.73v-.06l-3.94-4c-.86-.88-2.19.48-1.33 1.35l3.93 4h.06a13.38 13.38 0 0 1 -16.45 1s.01-.02.03-.02a8.63 8.63 0 0 1 3.32-4.19 1 1 0 0 0 -1-1.63 10.54 10.54 0 0 0 -4 4.66 13.4 13.4 0 0 1 -.82-18.75l4.21 4.2a.94.94 0 0 0 1.31-1.29l-4.2-4.21a13.41 13.41 0 0 1 18.88 18.94z"
      />
    </g>
  </svg>
</template>
